import {$assets} from '@/services/'

const module = {
  namespaced: true,

  state: {
    assetDetails: [],
    item: null,
    meta: { pagination: {} },
    assetDetail: null,
    scale: 1,
  },

  getters: {
    assetDetails: state => state.assetDetails,
    assetDetail: state=> state.assetDetail,
    scale: state=> state.scale,
    item: state => state.item,
    meta: state => state.meta,
  },

  mutations: {

    ITEM(state,value){
      state.item = value
    },

    ASSET_DETAILS(state,value){
      state.assetDetails = value
      state.assetDetail = value[0]
    },

    ASSET_DETAIL(state, value){
      state.assetDetail = value
    },

    SCALE(state, value){
      state.scale = value
    },

    META(state, meta){
      state.meta = meta
    },
  },

  actions: {
    
    find({ commit }, { id, config }){
      return $assets.show(id, config)
      .then(res => {
        let {data} = res.data
        commit('ASSET_DETAILS', data.asset_details)
        return res
      })
    },
    
    setScale({commit}, value){
      commit('SCALE', value)
    }

  }
}

export default module
